import {EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class AccountSearchData extends EntityData<AccountSearchData> {
    @identifier accountId: string;
    @field accountName: string;
    @field accountNo: number;
    @field limitDuration: number;
    @field creditLimit: number;
    @field currentBalance: number;
    @field type: string;
    @field discontinued: boolean;
}
